(function(angular, _) {
    angular.module('wtApp.dataService')
        .decorator('$locale', function($delegate) {
            // Extends the core provider to allow the external services to configure the $locale
            _.assign($delegate, {
                setNumberFormatSeparator(symbol) {
                    this.NUMBER_FORMATS.DECIMAL_SEP = String(symbol);
                },
                setNumberFormatGrouping(symbol) {
                    this.NUMBER_FORMATS.GROUP_SEP = String(symbol);
                },
                setNumberFormatCurrency(symbol) {
                    this.NUMBER_FORMATS.CURRENCY_SYM = String(symbol);
                }
            });

            return $delegate;
        });
})(window.angular, window._);
